import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
  loading: false,
  error: null,
  status: 'unauthenticated',
};

function toErrorMessage(p) {
  if (!p) return '登入失敗';
  if (typeof p === 'string') return p;
  return (
    p.msg ??
    p.error_description ??
    p.error ??
    p.message ??
    (() => { try { return JSON.stringify(p); } catch { return '登入失敗'; } })()
  );
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state) => {
      state.loading = true;
      state.error = null;
      state.data = {};
      state.status = 'unauthenticated';
    },
    loginSuccess: (state, action) => {
      state.data = action.payload?.data ?? {};
      state.status = 'authenticated';
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.error = toErrorMessage(action.payload);
      state.loading = false;
      state.status = 'unauthenticated';
    },
    clearUserError: (state) => {
      state.error = null;
    },
  },
});

export const selectUser = (state) => state.user;

export const { login, loginSuccess, loginFailure, clearUserError } = userSlice.actions;

export default userSlice.reducer;
